import { ConsentManagerProvider } from '@c15t/nextjs/headless';
import { type ReactNode } from 'react';

import { CONSENT_CATEGORIES } from './categories';
import { ConsentUiProvider } from './ConsentUiContext';
import { consentScripts } from './scripts';

type Props = {
  children: ReactNode;
};

/**
 * Offline c15t CMP: stores consent locally, loads registered scripts, and
 * signals Google Consent Mode. Wrap the app once in `_app`.
 */
const ConsentManager = ({ children }: Props) => {
  return (
    <ConsentManagerProvider
      options={{
        mode: 'offline',
        consentCategories: CONSENT_CATEGORIES,
        scripts: consentScripts,
      }}
    >
      <ConsentUiProvider>{children}</ConsentUiProvider>
    </ConsentManagerProvider>
  );
};

export default ConsentManager;
